import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import assert from '../utils/assert';
import getImageOutputFormat from './get-image-output-format';
import parseToNodeImage from './parse-to-node-image';
import parseToHTMLImage from './parse-to-html-image';
import parseToImageBitmap from './parse-to-image-bitmap';
import parseSVG from './parse-svg';
export default function parseImage(arrayBuffer, options, context) {
  var _ref, url, format;

  return _regeneratorRuntime.async(function parseImage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if ('image' in options) {
            options = _objectSpread({}, options, {
              image: {}
            });
          }

          _ref = context || {}, url = _ref.url;

          if (!(url && /\.svg((\?|#).*)?$/.test(url))) {
            _context.next = 7;
            break;
          }

          console.warn('@loaders.gl/images: SVG parsing needs to be fixed for 2.0');
          _context.next = 6;
          return _regeneratorRuntime.awrap(parseSVG(arrayBuffer, options));

        case 6:
          return _context.abrupt("return", _context.sent);

        case 7:
          format = getImageOutputFormat(options);
          _context.t0 = format;
          _context.next = _context.t0 === 'imagebitmap' ? 11 : _context.t0 === 'html' ? 14 : _context.t0 === 'ndarray' ? 17 : 20;
          break;

        case 11:
          _context.next = 13;
          return _regeneratorRuntime.awrap(parseToImageBitmap(arrayBuffer, options));

        case 13:
          return _context.abrupt("return", _context.sent);

        case 14:
          _context.next = 16;
          return _regeneratorRuntime.awrap(parseToHTMLImage(arrayBuffer, options));

        case 16:
          return _context.abrupt("return", _context.sent);

        case 17:
          _context.next = 19;
          return _regeneratorRuntime.awrap(parseToNodeImage(arrayBuffer, options));

        case 19:
          return _context.abrupt("return", _context.sent);

        case 20:
          return _context.abrupt("return", assert(false));

        case 21:
        case "end":
          return _context.stop();
      }
    }
  });
}